var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "row form-group" },
    [
      _vm.errors
        ? _c("div", { staticClass: "error" }, [
            _vm._v("\n        " + _vm._s(_vm.errorMessage) + "\n    "),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("label", [_vm._v("From Airport*")]),
      _vm._v(" "),
      _c("autocomplete", {
        model: {
          value: _vm.selectionFrom,
          callback: function ($$v) {
            _vm.selectionFrom = $$v
          },
          expression: "selectionFrom",
        },
      }),
      _vm._v(" "),
      _c("label", [_vm._v("To Airport*")]),
      _vm._v(" "),
      _c("autocomplete", {
        model: {
          value: _vm.selectionTo,
          callback: function ($$v) {
            _vm.selectionTo = $$v
          },
          expression: "selectionTo",
        },
      }),
      _vm._v(" "),
      _c("label", [_vm._v("Date*")]),
      _vm._v(" "),
      _c("date-picker", {
        attrs: { mode: "date" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (ref) {
              var inputValue = ref.inputValue
              var inputEvents = ref.inputEvents
              return [
                _c(
                  "input",
                  _vm._g({ domProps: { value: inputValue } }, inputEvents)
                ),
              ]
            },
          },
        ]),
        model: {
          value: _vm.selectedDate,
          callback: function ($$v) {
            _vm.selectedDate = $$v
          },
          expression: "selectedDate",
        },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "row form-group" }, [
        _c("button", { staticClass: "button", on: { click: _vm.submitForm } }, [
          _vm._v("Submit"),
        ]),
      ]),
      _vm._v(" "),
      _vm.results
        ? _c("div", { staticClass: "row form-group" }, [
            _c(
              "table",
              [
                _vm._m(0),
                _vm._v(" "),
                _vm._l(_vm.results, function (flight, index) {
                  return _c("tr", { key: index, class: _vm.getClass(index) }, [
                    _c("td", [_vm._v(_vm._s(flight.skeddep))]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(flight.skedarr))]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(flight.actdep))]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(flight.actarr))]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(flight.flCarrier))]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(flight.flnum))]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(flight.tail_num))]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(flight.fldate))]),
                  ])
                }),
              ],
              2
            ),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("th", [_vm._v("Scheduled Departure")]),
      _vm._v(" "),
      _c("th", [_vm._v("Scheduled Arrival")]),
      _vm._v(" "),
      _c("th", [_vm._v("Actual Departure")]),
      _vm._v(" "),
      _c("th", [_vm._v("Actual Arrival")]),
      _vm._v(" "),
      _c("th", [_vm._v("Carrier")]),
      _vm._v(" "),
      _c("th", [_vm._v("Flight Number")]),
      _vm._v(" "),
      _c("th", [_vm._v("Tail Number")]),
      _vm._v(" "),
      _c("th", [_vm._v("Date")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }